/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useState, useContext } from 'react';
import {
  Card,
  Stack,
  Tabs,
  TabList,
  Tab,
  Heading,
  Button,
  HStack,
  Spinner,
  Text,
  useDisclosure,
} from '@mybridge/ui';
import { MyProfileContext } from 'v4/components/profile/context';
import {
  EarthGlobeIcon,
  EditIcon,
  OnlyMeLockIcon,
  TeamIcon,
} from '@mybridge/icons';
import styles from './videos.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CreateAudiencePermissionModal } from 'v4/components/profile/audience-modal-create';
import PhotoActionsMenu from 'v4/components/profile/photo-actions-menu';
import DashboardReelModal from 'v4/components/ReelModal/DashboardReelModal';
import ImageModal from 'v4/components/imageModal/ImageModal';
import _ from 'lodash';
import { DashboardPostForm } from 'v4/snippets/dashboard/post-form';
import { Link } from '@mybridge/ui/link';
import { fancyTimeFormat } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyProfileVideos = () => {
  const {
    userProfileInfo,
    photosOfYouCount,
    hasPhotosOfYou,
    photosOfYou,
    refetchPhotosOfyou,
    photosOfYouHasNextPage,
    photosOfYouFetchNextPage,
    yourPhotos,
    yourPhotosCount,
    hasYourPhotos,
    refetchYourPhotos,
    yourPhotosHasNextPage,
    yourPhotosFetchNextPage,
    yourVideos,
    hasYourVideos,
    yourVideosCount,
    refetchyourVideos,
    yourVideosHasNextPage,
    yourVideosFetchNextPage,
    videosOfYou,
    hasVideosOfYou,
    videosOfYouCount,
    refetchvideosOfYou,
    videosOfYouHasNextPage,
    videosOfYouFetchNextPage,
  } = useContext(MyProfileContext);
  const { t } = useTranslator();

  const introValue = _.get(userProfileInfo, 'field_audience.media_videos');
  const [activeTab, setActiveTab] = useState(0);
  const audienceCreateDisc = useDisclosure();
  const [audienceValue, setAudienceValue] = useState(introValue);
  const [activeVideoTab, setActiveVideoTab] = useState(0);
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);

  const [reelModel, setReelModel] = useState(false);
  const [reelModelProps, setReelModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  const [imageModel, setImageModel] = useState(false);
  const [imageModelProps, setImageModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  // const [aggregatedData, setAggregatedData] = useState(null);

  useEffect(() => {
    if (userProfileInfo) {
      refetchPhotosOfyou?.({ slug: userProfileInfo.slug });
      refetchYourPhotos?.({ user: userProfileInfo.slug });
      refetchyourVideos?.({ user: userProfileInfo.slug });
      refetchvideosOfYou?.({ user: userProfileInfo.slug });
    }
  }, [userProfileInfo]);

const refetchPhotos = () => {
  setIsPostModalOpen(false);
  refetchPhotosOfyou?.({ slug: userProfileInfo.slug });
  refetchYourPhotos?.({ user: userProfileInfo.slug });
  refetchyourVideos?.({ user: userProfileInfo.slug });
  refetchvideosOfYou?.({ user: userProfileInfo.slug });
};

  const PhotosTabsArray = [
    {
      title: t('profilePhotosVideos.photosOfYou') || 'Photos of you',
    },
    {
      title: t('profilePhotosVideos.yourPhotos') || 'Your Photos',
    },
  ];
  const VideosTabsArray = [
    {
      title: t('profilePhotosVideos.videosOfYou') || 'Videos of you',
    },
    {
      title: t('profilePhotosVideos.yourVideos') || 'Your videos',
    },
  ];

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
    }
  };
  return (
    <>
      <Card variant="thinBorderedCard" mb={6} p={4}>
        <div className={styles.headerCont2}>
          <div className={styles.heading1}>
            {t('profilePhotosVideos.videos') || 'Videos'}
            <Button
              ml={6}
              ph="10px"
              borderRadius="50px"
              leftIcon={renderPermissionSwitch(introValue)?.icon}
              type="button"
              onClick={() => {
                audienceCreateDisc.onOpen();
              }}
            >
              {renderPermissionSwitch(introValue)?.text}
            </Button>
          </div>
          <Heading
            fontSize="17px"
            color="brandPrimary.500"
            mb={3}
            fontWeight="400"
            className={styles.addMedia}
            onClick={() => setIsPostModalOpen(true)}
          >
            {t('profilePhotosVideos.addPhotoVideo') || 'Add photo/video'}
          </Heading>
        </div>
        {isPostModalOpen && (
          <DashboardPostForm
          onCreateSuccess={(e, isVideo) => {
            if (!!isVideo) {
              setTimeout(() => {
                refetchPhotos();
              }, 25000);
            } else {
              refetchPhotos();
            }
          }}
            onClose={() => setIsPostModalOpen(false)}
            isFromProfile={true}
          />
        )}
        <Stack minH="300px">
          <Tabs index={activeVideoTab} mb={6} justifyContent="space-between">
            <TabList borderBottomColor="transparent">
              {VideosTabsArray.map((t, index) => (
                <div key={index} onClick={() => setActiveVideoTab(index)}>
                  <Tab>{t?.title}</Tab>
                </div>
              ))}
            </TabList>
          </Tabs>

          {activeVideoTab === 0 && (
            <CustomInfiniteVideoScroll
              isActiveIndex={activeVideoTab}
              dataLength={videosOfYouCount}
              next={videosOfYouFetchNextPage}
              hasMore={videosOfYouHasNextPage}
              isVideos={hasVideosOfYou}
              videosArray={videosOfYou}
              setReelModel={setReelModel}
              setReelModelProps={setReelModelProps}
            />
          )}
          {activeVideoTab === 1 && (
            <CustomInfiniteVideoScroll
              isActiveIndex={activeVideoTab}
              dataLength={yourVideosCount}
              next={yourVideosFetchNextPage}
              hasMore={yourVideosHasNextPage}
              isVideos={hasYourVideos}
              videosArray={yourVideos}
              setReelModel={setReelModel}
              setReelModelProps={setReelModelProps}
            />
          )}
        </Stack>
      </Card>
      {reelModel && <DashboardReelModal {...reelModelProps} />}

      <Card variant="thinBorderedCard" mb={6} p={4}>
        <Stack>
          <div className={styles.headerCont2}>
            <div className={styles.heading1}>{t('profilePhotosVideos.photos') || 'Photos'}</div>
            <div className={styles.linkText}>
              <Link href="/profile/photos">{t('profilePhotosVideos.seeAll') || 'See all'}</Link>
            </div>
          </div>
        </Stack>
        <Stack minH="300px">
          <Tabs index={activeTab} mb="24px">
            <TabList borderBottomColor="transparent">
              {PhotosTabsArray.map((t, index) => (
                <div key={index} onClick={() => setActiveTab(index)}>
                  <Tab>{t?.title}</Tab>
                </div>
              ))}
            </TabList>
          </Tabs>
          {activeTab === 0 && (
            <CustomInfiniteScroll
              isActiveIndex={activeTab}
              dataLength={photosOfYouCount}
              next={photosOfYouFetchNextPage}
              hasMore={photosOfYouHasNextPage}
              isPhotos={hasPhotosOfYou}
              photosArray={photosOfYou}
              setImageModel={setImageModel}
              setImageModelProps={setImageModelProps}
            />
          )}
          {activeTab === 1 && (
            <CustomInfiniteScroll
              isActiveIndex={activeTab}
              dataLength={yourPhotosCount}
              next={yourPhotosFetchNextPage}
              hasMore={yourPhotosHasNextPage}
              isPhotos={hasYourPhotos}
              photosArray={yourPhotos}
              setImageModel={setImageModel}
              setImageModelProps={setImageModelProps}
            />
          )}
        </Stack>
      </Card>

      {imageModel && <ImageModal {...imageModelProps} />}

      {audienceCreateDisc?.isOpen ? (
        <CreateAudiencePermissionModal
          {...audienceCreateDisc}
          audienceValue={audienceValue}
          setPermissionValue={(e) => setAudienceValue(e)}
          media={'media_videos'}
        />
      ) : (
        ''
      )}
    </>
  );
};

const CustomInfiniteScroll = ({
  dataLength = 1,
  isActiveIndex,
  next,
  hasMore = false,
  isPhotos,
  photosArray,
  setImageModelProps,
  setImageModel,
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={hasMore && next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isPhotos ? '' : t('profilePhotosVideos.noPhotos') || 'No photos to show'}
          </Text>
        }
      >
        {isPhotos &&
          photosArray.map((Img, i) =>
            Img?.media?.length > 1 ? (
              Img?.media?.map((MultiImg, multiIndex) => (
                <div className={styles.card2} key={multiIndex}>
                  <img
                    src={MultiImg?.file}
                    alt="post image"
                    className={styles.img2}
                    onClick={() => {
                      const props = {
                        onClose: () => setImageModel(false),
                        postsData: photosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setImageModelProps(props);
                      setImageModel(true);
                    }}
                  />
                  <div className={styles.iconCont1}>
                    <PhotoActionsMenu
                      isPhotos={true}
                      isActiveIndex={isActiveIndex}
                      imageData={MultiImg}
                      selectedImgPost={Img}
                      selctedImage={MultiImg}
                    />
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.card2}>
                <img
                  src={Img.media?.[0]?.file}
                  alt="post image"
                  className={styles.img2}
                  onClick={() => {
                    const props = {
                      onClose: () => setImageModel(false),
                      postsData: photosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setImageModelProps(props);
                    setImageModel(true);
                  }}
                />
                <div className={styles.iconCont1}>
                  <PhotoActionsMenu
                    isPhotos={true}
                    isActiveIndex={isActiveIndex}
                    imageData={Img?.media?.[0]}
                    selectedImgPost={Img}
                  />
                </div>
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};

const CustomInfiniteVideoScroll = ({
  dataLength = 1,
  isActiveIndex,
  next,
  hasMore = false,
  isVideos,
  videosArray,
  setReelModel,
  setReelModelProps,
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={hasMore && next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isVideos ? '' : t('profilePhotosVideos.noVideos') || 'No Videos to show'}
          </Text>
        }
      >
        {isVideos &&
          videosArray.map((vid, i) =>
            vid.media?.length > 1 ? (
              vid?.media?.map((MultiVid, multiIndex) => (
                <div className={styles.card2} key={multiIndex}>
                  <video
                    src={MultiVid?.file}
                    alt="post image"
                    className={styles.vid1}
                    onClick={() => {
                      const props = {
                        onClose: () => setReelModel(false),
                        postsData: videosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setReelModelProps(props);
                      setReelModel(true);
                    }}
                  />
                  <div className={styles.iconCont1}>
                    <PhotoActionsMenu
                      isPhotos={false}
                      isActiveIndex={isActiveIndex}
                      imageData={MultiVid}
                      selectedImgPost={vid}
                      selctedImage={MultiVid}
                    />
                  </div>
                  <div className={styles.videoLengthCont}>
                    {MultiVid?.duration
                      ? fancyTimeFormat(MultiVid?.duration)
                      : ''}
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.card2}>
                <video
                  src={vid.media?.[0]?.file}
                  alt="post image"
                  className={styles.vid1}
                  onClick={() => {
                    const props = {
                      onClose: () => setReelModel(false),
                      postsData: videosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setReelModelProps(props);
                    setReelModel(true);
                  }}
                />
                <div className={styles.iconCont1}>
                  <PhotoActionsMenu
                    isPhotos={false}
                    isActiveIndex={isActiveIndex}
                    imageData={vid?.media?.[0]}
                    selectedImgPost={vid}
                  />
                </div>
                <div className={styles.videoLengthCont}>
                  {vid.media?.[0]?.duration
                    ? fancyTimeFormat(vid.media?.[0]?.duration)
                    : ''}
                </div>
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};
